/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.33.0.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

import { Addr, Uint128, ContractMode, InstantiateMsg, ContractConfig, Coin, ExecuteMsg, AdminMethodExecMsg, Binary, ExecMsg, HexBinary, RewardWasm, QueryMsg, AdminMethodQueryMsg, QueryMsg1, Nullableuint64, ContractState, StateResponse, OpeningQueueItem, Reward, RewardBasket, RewardCw721, RewardCw721Item, ArrayOfTupleOfUint64AndString } from "./LootboxContract.types";
import { CamelCasedProperties } from "type-fest";
export abstract class LootboxContractExecuteMsgBuilder {
  static start = (): ExecuteMsg => {
    return {
      start: ({} as const)
    };
  };
  static createNewReward = ({
    quantity,
    rewardId,
    unlimited,
    weight
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    create_new_reward: unknown;
  }>["create_new_reward"]>): ExecuteMsg => {
    return {
      create_new_reward: ({
        quantity,
        reward_id: rewardId,
        unlimited,
        weight
      } as const)
    };
  };
  static addItemToReward = ({
    bank,
    rewardId,
    wasm
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    add_item_to_reward: unknown;
  }>["add_item_to_reward"]>): ExecuteMsg => {
    return {
      add_item_to_reward: ({
        bank,
        reward_id: rewardId,
        wasm
      } as const)
    };
  };
  static removeItem = ({
    bank,
    nfts,
    rewardId,
    wasm
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    remove_item: unknown;
  }>["remove_item"]>): ExecuteMsg => {
    return {
      remove_item: ({
        bank,
        nfts,
        reward_id: rewardId,
        wasm
      } as const)
    };
  };
  static removeReward = ({
    rewardId
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    remove_reward: unknown;
  }>["remove_reward"]>): ExecuteMsg => {
    return {
      remove_reward: ({
        reward_id: rewardId
      } as const)
    };
  };
  static disable = (): ExecuteMsg => {
    return {
      disable: ({} as const)
    };
  };
  static pause = (): ExecuteMsg => {
    return {
      pause: ({} as const)
    };
  };
  static receiveNft = ({
    msg,
    sender,
    tokenId
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    receive_nft: unknown;
  }>["receive_nft"]>): ExecuteMsg => {
    return {
      receive_nft: ({
        msg,
        sender,
        token_id: tokenId
      } as const)
    };
  };
  static openBox = ({
    player,
    quantity
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    open_box: unknown;
  }>["open_box"]>): ExecuteMsg => {
    return {
      open_box: ({
        player,
        quantity
      } as const)
    };
  };
  static draw = ({
    round,
    signature
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    draw: unknown;
  }>["draw"]>): ExecuteMsg => {
    return {
      draw: ({
        round,
        signature
      } as const)
    };
  };
  static payout = ({
    payoutId,
    player
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    payout: unknown;
  }>["payout"]>): ExecuteMsg => {
    return {
      payout: ({
        payout_id: payoutId,
        player
      } as const)
    };
  };
  static adminUpdateConfig = ({
    config
  }: CamelCasedProperties<Extract<ExecuteMsg, {
    admin_update_config: unknown;
  }>["admin_update_config"]>): ExecuteMsg => {
    return {
      admin_update_config: ({
        config
      } as const)
    };
  };
}
export abstract class LootboxContractQueryMsgBuilder {
  static getNextRound = (): QueryMsg => {
    return {
      get_next_round: ({} as const)
    };
  };
  static getUserReward = ({
    address
  }: CamelCasedProperties<Extract<QueryMsg, {
    get_user_reward: unknown;
  }>["get_user_reward"]>): QueryMsg => {
    return {
      get_user_reward: ({
        address
      } as const)
    };
  };
  static getState = ({
    config,
    index,
    mode,
    openingQueue,
    payouts,
    rewards,
    rewardsBasket,
    rewardsRemainingQuantity,
    salt,
    state
  }: CamelCasedProperties<Extract<QueryMsg, {
    get_state: unknown;
  }>["get_state"]>): QueryMsg => {
    return {
      get_state: ({
        config,
        index,
        mode,
        opening_queue: openingQueue,
        payouts,
        rewards,
        rewards_basket: rewardsBasket,
        rewards_remaining_quantity: rewardsRemainingQuantity,
        salt,
        state
      } as const)
    };
  };
}